import React from "react";
import styles from "./TextOnPictureBig.module.scss";


interface Props {
  data: {
  path: string;
  url: string;
  title: string;
  price: string;
}
}
const TextOnPictureBig = ({data}: Props) => {
  return (
    <a href={data.path}>
      <div
        className={styles.textOnPicture}
        style={{ backgroundImage: `url(${data.url})` }}
      >
        <div className={styles.sup} />
        <div className={styles.toHover}>
          <div className={styles.back} />
          <div className={styles.text}>
            {data.title}
            <div className={styles.price}> {data.price} </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default TextOnPictureBig;
